import React from 'react';
import { BaasicInput } from 'core/components';
import { translate, selectLogo, isSome } from 'core/utils';
import { defaultTemplate } from 'core/hoc';
import { Button, ButtonGroup } from '@progress/kendo-react-buttons';
import BasicRadio from 'themes/components/forms/BasicRadio';
import Countdown from 'react-countdown';

const AppPasswordRecoveryTemplate = ({
	t,
	viewStore: {
		appPasswordRecoveryViewStore: {
			form,
			loading,
			goToLogin,
			smsOption,
			onToggleVerificationOption,
			errorMessage,
			timer,
			verificationCodeSent,
			resendMessage,
			sendResetPasswordCode,
			resetTimerData,
			emailSent,
			resendResetPasswordEmail,
		},
	},
}) => {
	var logo_show = selectLogo();

	const addZeroBefore = number => {
		return (number < 10 ? '0' : '') + number;
	};

	const renderer = ({ minutes, seconds }) => {
		minutes = addZeroBefore(minutes);
		seconds = addZeroBefore(seconds);
		return (
			<p className="type--color--warning type--pre-line spc--bottom--sml">{t(errorMessage, { minutes, seconds })}</p>
		);
	};
	return (
		<main className="body--secondary">
			<section className="w--400--px align--h--center padd--top--med ">
				<img className="w--200--px display--b align--h--center" src={logo_show} alt="Logo" />
				{emailSent ? (
					<React.Fragment>
						<div className="form card card--med spc--top--med type--center">
							<img className="w--100--px display--b align--h--center spc--bottom--med" src={require('themes/img/email-send.svg')} alt="Email icon" />
							<p className="spc--bottom--sml w--70 align--h--center">{t('PASSWORDRECOVERYFORM.SENDEMAILSUCCESS')}</p>
							<button
								onClick={() => resendResetPasswordEmail()}
								className="btn btn--ghost type--wgt--bold"
								disabled={loading}
							>
								{t('PASSWORDRECOVERYFORM.RESENDEMAIL')}
							</button>
						</div>
					</React.Fragment>
				) : (
					<form className="form card card--med spc--top--med" onSubmit={form.onSubmit}>
						<h3 className="spc--bottom--sml">{t('FORGOTYOURPASSWORD')}</h3>

						{!verificationCodeSent && (
							<React.Fragment>
								<p className="spc--bottom--sml message message--default">
									{t('PASSWORDRECOVERYFORM.ENTERYOURSIGNUPEMAILANDORGANIZATIONIDENTIFIER')}
								</p>
								<BaasicInput field={form.$('organizationIdentifier')} />
								<BaasicInput field={form.$('usernameOrEmail')} />
								{resetPasswordInitial(
									t,
									smsOption,
									onToggleVerificationOption,
									form,
									errorMessage,
									timer,
									renderer,
									resetTimerData,
									loading,
									goToLogin
								)}
							</React.Fragment>
						)}

						{verificationCodeSent &&
							verifyCodeToResetPassword(t, form, sendResetPasswordCode, loading, resendMessage, errorMessage)}
					</form>
				)}
			</section>
		</main>
	);
};

function resetPasswordInitial(
	t,
	smsOption,
	onToggleVerificationOption,
	form,
	errorMessage,
	timer,
	renderer,
	resetTimerData,
	loading,
	goToLogin
) {
	return (
		<React.Fragment>
			<p className="spc--bottom--sml message message--default">{t('CHOOSE2FAMETHOD')}</p>
			<ButtonGroup className="k-button-group--carrier spc--bottom--sml">
				<Button
					togglable={true}
					selected={smsOption}
					onClick={() => onToggleVerificationOption(true)}
					type="button"
					icon="icon icon--sms"
				>
					<BasicRadio
						field={form.$('sms')}
						value={smsOption}
						name="sms"
						label={'TWOSTEPAUTHENTICATION.SMS'}
						className="input--radio"
					></BasicRadio>
				</Button>
				<Button
					togglable={true}
					selected={!smsOption}
					onClick={() => onToggleVerificationOption(false)}
					type="button"
					icon="icon icon--phone"
				>
					<BasicRadio
						field={form.$('voiceCall')}
						value={!smsOption}
						name="voiceCall"
						label={'TWOSTEPAUTHENTICATION.VOICECALL'}
						className="input--radio"
					></BasicRadio>
				</Button>
			</ButtonGroup>
			{form.error && (
				<div>
					<p className="type--color--warning">{translate(form.error)}</p>
				</div>
			)}
			<div className="group">
				{errorMessage && isSome(timer) && (
					<Countdown
						autoStart={true}
						date={timer.date + timer.delay}
						renderer={renderer}
						onComplete={() => resetTimerData()}
					/>
				)}
				{errorMessage && !isSome(timer) && (
					<React.Fragment>
						<p className="type--color--warning spc--bottom--sml">{t(errorMessage)}</p>
					</React.Fragment>
				)}
				<button type="submit" className="btn btn--med btn--primary" disabled={loading || isSome(timer)}>
					{loading ? (
						<div className="spinnercont spc--right--sml">
							<div className="spinner"></div>
						</div>
					) : null}
					{t('RESETPASSWORD')}
				</button>
				<a className="push btn btn--med btn--ghost" onClick={goToLogin}>
					{t('BACK')}
				</a>
			</div>
		</React.Fragment>
	);
}

function verifyCodeToResetPassword(t, form, sendResetPasswordCode, loading, resendMessage, errorMessage) {
	return (
		<React.Fragment>
			<div className="card__body">
				<div className="spc--bottom--sml">{t('TWOSTEPAUTHENTICATION.CODESENTMESSAGE')}</div>
				<BaasicInput field={form.$('verificationCode')} autoFocus showCheckmark={false} />
				{form.error && (
					<React.Fragment>
						<p className="type--color--warning spc--bottom--sml">{translate(form.error)}</p>
					</React.Fragment>
				)}
				<div className="spc--bottom--sml">
					<div className="flex flex--primary flex--align--baseline">
						<React.Fragment>
							<p>{t('TWOSTEPAUTHENTICATION.DIDNTRECEIVEACODE')}</p>
						</React.Fragment>
						<button
							onClick={() => sendResetPasswordCode(true)}
							className="btn btn--ghost type--wgt--bold"
							disabled={loading}
						>
							{t('TWOSTEPAUTHENTICATION.RESEND')}
						</button>
					</div>
					{resendMessage && !loading && (
						<React.Fragment>
							<p className="type--tny type--color--success">{t('TWOSTEPAUTHENTICATION.CODERESENT')}</p>
						</React.Fragment>
					)}
				</div>
				{errorMessage && <p className="type--color--warning spc--bottom--sml">{t(errorMessage)}</p>}
				<button className="btn btn--med btn--primary" type="submit" disabled={loading}>
					{loading ? (
						<div className="spinnercont spc--right--sml">
							<div className="spinner"></div>
						</div>
					) : null}
					{t('TWOSTEPAUTHENTICATION.VERIFYCODE')}
				</button>
			</div>
		</React.Fragment>
	);
}

export default defaultTemplate(AppPasswordRecoveryTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/membership/pages/AppPasswordRecoveryTemplate.jsx